export default "__VITE_ASSET__XDRZC5w1__"